/**
 * @async
 * @function filterTabs
 * @param { array } groups
 * @param { array } menus
 * @param { array } tabs
 * @returns { Promise<Array> }
 */
function filterTabs(groups, menus, tabs) {
	let _tabs = [];

	for (let i = 0; i < groups.length; i++) {
		for (let j = 0; j < menus.length; j++) {
			if (groups[i].id === menus[j].roleGroupId) {
				for (let k = 0; k < tabs.length; k++) {
					if (menus[j].tabId === tabs[k].id) {
						const tempObj = {
							name: tabs[k].name,
							url: tabs[k].url,
							order: menus[j].order,
							submenuId: menus[j].submenuId,
							appName: groups[i].appName,
						};
						_tabs.push(tempObj);
					}
				}
			}
		}
	}

	return _tabs;
}

export default filterTabs;
